import {ID} from '.';

export enum NoticePushStatus {
  QUEUED = 'queued',
  SENDING = 'sending',
  SENT = 'sent',
  FAILED = 'failed',
  BLOCKED = 'blocked',
}

export const NoticePushStatusNames = {
  queued: '발송 대기',
  sending: '발송 중',
  sent: '발송 완료',
  failed: '발송 실패',
  blocked: '발송 차단',
};

export interface INotice {
  id: ID;

  createdAt: Date;
  updatedAt: Date;
  enabled: boolean;

  title: string;
  content: string;

  viewCount: number;

  //
  // 앱 푸시
  pushStatus?: NoticePushStatus;
  pushSentAt?: Date;
  pushMessageId?: string;
  pushError?: string;

  //
  // 앱
  read?: boolean;
}
